module.exports = __webpack_public_path__ + "static/media/masala-veggie-burger-dt-fr.9157ef61.jpg";